export enum TransferTabs {
  TYPE = '1',
  RECEIVER = '2',
  VALUE = '3',
  CONFIRMATION = '4',
  DETAILS = '5',
}
